import React, { useEffect, useState } from "react";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import CustomTable from "../../../components/table/table";
import {
  admin_draft_policy_delete,
  admin_draft_policies_list,
} from "../admin.api";
import ManageDraftPolicies from "./manage/manage";
import "../policies/view.css";
import jwtDecode from "jwt-decode";
import ReactHtmlParser from "react-html-parser";

export default function DraftPoliciesList(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const [data, setData] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [view, setView] = useState(false);

  const handleEventList = () => {
    setIsActive(true);
    admin_draft_policies_list().then((res) => {
      let tdata = res.data || [];
      tdata.forEach((item, index) => {
        item["slno"] = index + 1;
      });
      setData(tdata);
      setIsActive(false);
    });
  };

  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance ? servInstance.substring(0, servInstance?.length - 4) : "";

  const handleDownload = (filePath) => {
    if (!filePath) return;
    let path = `${result}${filePath}`;
    window.open(path, "_blank");
  };

  useEffect(() => {
    handleEventList();
  }, []);

  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    handleEventList();
  };

  const handleEdit = (row) => {
    setFormData(row);
    setView(false);
    setEdit(true);
    setAddNew(true);
  };

  const handleAddNew = () => {
    setFormData({});
    setEdit(false);
    setView(false);
    setAddNew(true);
  };

  const handleDelete = (row) => {
    setActiveData(row);
    setOpenAction(true);
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const handleDeleteConfirm = (row) => {
    setOpenAction(false);
    setIsActive(true);
    admin_draft_policy_delete(row.id)
      .then((res) => {
        setSnackMessage(res.message || "Deleted successfully");
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message || "Failed to delete");
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleEventList();
    }
  };

  const handleView = (row) => {
    setFormData(row);
    setAddNew(true);
    setView(true);
  };

  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Draft Policy</b>
        </h6>

        <hr />
        {(adminType === 1 || adminType === 2) && (
          <button
            type="button"
            className="btn btn-primary btn-sm mb-2"
            onClick={handleAddNew}
          >
            Add New
          </button>
        )}
        <CustomTable
          {...props}
          columns={[
            { title: "Sl. No", type: "dynId" },
            { title: "Title [Eng]", field: "title" },
            { title: "Title [Mal]", field: "title_ma" },
            {
              title: "Description",
              field: "description",
              render: (rowData) => (
                <div>{ReactHtmlParser(rowData.description)}</div>
              ),
            },
            { title: "Feedback Last Date", field: "feedback_last_date" },
            {
              title: "Doc [Eng]",
              field: "document_eng",
              render: (rowData) =>
                rowData.document_eng ? (
                  <button
                    className="btn btn-link btn-sm p-0"
                    onClick={() => handleDownload(rowData.document_eng)}
                  >
                    Download (Eng)
                  </button>
                ) : (
                  "-"
                ),
            },
            {
              title: "Doc [Mal]",
              field: "document_mal",
              render: (rowData) =>
                rowData.document_mal ? (
                  <button
                    className="btn btn-link btn-sm p-0"
                    onClick={() => handleDownload(rowData.document_mal)}
                  >
                    Download (Mal)
                  </button>
                ) : (
                  "-"
                ),
            },
            {
              title: "Feedback Link",
              field: "feedback_form",
              render: (rowData) =>
                rowData.feedback_form ? (
                  <a
                    href={
                      rowData.feedback_form.toLowerCase().startsWith("http")
                        ? rowData.feedback_form
                        : `//${rowData.feedback_form}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Link
                  </a>
                ) : (
                  "-"
                ),
            },
          ]}
          data={data}
          actions={[
            { type: "view", handleClick: handleView },
            { type: "edit", handleClick: handleEdit },
            { type: "delete", handleClick: handleDelete },
          ]}
        />
      </div>
      {addNew && (
        <ManageDraftPolicies
          open={addNew}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
        />
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Draft Policy"
          data={activeData}
          message="Are you sure you want to delete this draft policy?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
